export default __webpack_public_path__ + "static/RootSans-8SemiBoldItalic-58483b5318ad3058b7e03e23b3664e6d.woff";